import moment from "moment";
import {PuiChip} from "@portnet/ui";
import {getChipColorByEtatCodePackage} from "../../detailPackage/data/colors";
import {formatPrices} from "../../../../common/utils/helpers";

export const consultationPackageTableColumns = [
  {
    field: "code",
    headerName: "Code package",
    flex: 1.5,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.code ?? "-",
  },
  {
    field: "roleOperateur",
    headerName: "Rôle",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.roleOperateur?.description ?? "-",
  },

  {
    field: "typePaiment",
    headerName: "Paiement",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.typePaiment.description ?? "-",
  },
  {
    field: "nbrTransaction",
    headerName: "Transactions",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.typeTransactionAutorisee.description === "Illimité" ? row.typeTransactionAutorisee.description : row.nbrTransaction ?? "-"
  },
  {
    field: "abonnementBase",
    headerName: "Frais d'accès TTC",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.abonnementBase ?  formatPrices(( row.abonnementBase* 1.2)) : "-",
  },
  {
    field: "fraisService",
    headerName: "Tarif TTC",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.fraisService ?  formatPrices( row.fraisService* 1.2) : "-",
  },
  {
    field: "validiteePackage",
    headerName: "Validité",
    flex: 1.5,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.validitePackageLibelle?? "-",
  },
  {
    field: "typeFraisService",
    headerName: "Type frais de service",
    flex: 1.5,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.typeFraisService?.description ?? "-",
  },
  {
    field: "statut",
    headerName: "Statut",
    sortable: false,
    flex: 1.2,
    renderCell: ({ row }) => (
        <PuiChip
            color={getChipColorByEtatCodePackage(row.statut.code)}
            fullWidth
        >
          {row.statut?.description ?? "-"}
        </PuiChip>
    ),
  },
];

export const historiquePackageTableColumns = [
  {
    field: "sequence",
    headerName: "Séquence",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.sequence ?? "-",
  },
  {
    field: "userName",
    headerName: "Utilisateur",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.user?.userName ?? "-",
  },
  {
    field: "evenement",
    headerName: "Évènement",
    flex: 2,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.evenement ?? "-",
  },
  {
    field: "dateCreation",
    headerName: "Date",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) =>
      Boolean(row.dateCreation)
        ? moment(row.dateCreation).format("DD/MM/YYYY LT")
        : "-",
  },
  {
    field: "etatDescription",
    headerName: "État package",
    flex: 1,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.etatDescription ?? "-",
  },
  {
    field: "informationEvenement",
    headerName: "Information évènement",
    flex: 3,
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.informationEvenement ?? "-",
  },
];
